export const FETCH_CHECKOUTS = '[CHECKOUT]FETCH_CHECKOUTS';
export const FETCH_CHECKOUTS_SUCCESS = '[CHECKOUT]FETCH_CHECKOUTS_SUCCESS';
export const FETCH_CHECKOUTS_FAILED = '[CHECKOUT]FETCH_CHECKOUTS_FAILED';

export const VOID_CHECKOUT = `[CHECKOUT]VOID_CHECKOUT`;

export const PRINT_LONG_BILL = `[CHECKOUT]PRINT_LONG_BILL`;
